import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { useTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MyDialog = ({title='', component, dialogHandler, callback}) => {
  // const [open, setOpen] = React.useState(false);
  const theme = useTheme()
  const handleOpen = () => {
    // setOpen(true);
    dialogHandler[1](true)
  };

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return
    }
    // setOpen(false);
    dialogHandler[1](false)
    if(callback) {
      callback()
    }
  };

    
  return (
    <div>
      <Dialog
        fullScreen
        open={dialogHandler[0]}
        onClose={handleClose}
        // {TransitionComponent={Transition}}
      >
        <AppBar sx={{ position: 'relative', bgcolor:theme.palette.primary.bar }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div" align='center'>
              {title}
            </Typography>
            
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        {component}
      </Dialog>
    </div>
  );
}

export default MyDialog
